import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* env */
import { env } from "../../constants"

/* Components */
import { Input } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Widgets */
import Layout from "./Layout"

/* Swal */
import Swal from "sweetalert2"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* REST API */
import { getSettings as get, saveSettings as save, removeSettings as remove } from "../../api/Table"

/* Copy To Clipboard */
import { CopyToClipboard } from "react-copy-to-clipboard"



/* Widget Settings */
class Settings extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: null,
            waiting: false,

            name: "",
            slug: "",
            game: "",
            gameURL: "",
            backURL: "",
            backColor: "",
            room: "",
            type: "",

            gameImgUrl: "",
            gameImg: null,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Table Data */
    load = (reload = false) => {

        /* Fields */
        const { uid, operators } = this.props

        /* Check Params */
        if (!uid && !(operators && Array.isArray(operators) && operators.length > 0)) {
            this.setState({ status: "error" })
            return
        }

        /* Refresh the page if necessary */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        get({ uid, ids: utils.arrayID(operators) }).then((response) => {
            if (response.status === 200) {
                const data = response.data

                this.setState({
                    status: "ok",
                    data,
                    name: utils.checkValue(data.name),
                    slug: utils.checkValue(data.slug),
                    game: utils.checkValue(data.game),
                    gameURL: utils.checkValue(data.gameURL),
                    backURL: utils.checkValue(data.backURL),
                    backColor: utils.checkValue(data.backColor),
                    room: utils.checkValue(data.room),
                    type: utils.checkValue(data.type),
                    gameImgUrl: data.gameImg ? `${env.point}/images/table-images/${data.gameImg}` : null,
                })

            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission" })
            }
            else if (response.status === 498) {
                this.setState({ status: "key" })
            }
            else {
                this.setState({ status: "error" })
            }
        }).catch(() => {
            this.setState({ status: "network" })
        })
    }


    /* Remove Table */
    remove = () => {

        /* Fields */
        const { uid, navigate } = this.props

        /* Check Params */
        if (!uid) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        Swal.fire({
            title: t("swal.deleteGame"),
            text: t("swal.deleteGameWarning"),
            showCancelButton: true,
            cancelButtonColor: "#999",
            cancelButtonText: t("swal.cancelButton2"),
            confirmButtonColor: "#f44336",
            confirmButtonText: t("swal.deleteButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                remove({ uid }).then((response) => {
                    if (response.status === 200) {
                        Swal.fire(utils.notification(t("swal.gameDeleted"), "success")).then(() => navigate("/game"))
                    }
                    else {
                        Swal.fire(utils.notification(t("widget.unknownError"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("widget.unknownError"), "error"))
                })
            }
        })
    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { name, slug, game, gameURL, backURL, backColor, gameImg, room, type } = this.state
        const { uid } = this.props

        /* Check Params */
        if (!uid) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        if (name === "") {
            this._name.error(t("settings.enterName"))
            return
        }

        if (slug === "") {
            this._slug.error(t("settings.enterKey"))
            return
        }

        if (game === "") {
            this._slug.error(t("settings.enterGame"))
            return
        }

        const data = new FormData()

        data.append("uid", uid)
        data.append("name", name)
        data.append("slug", slug)
        data.append("game", game)
        data.append("gameURL", gameURL)
        data.append("backURL", backURL)
        data.append("backColor", backColor)
        data.append("room", room)
        data.append("type", type)

        if (gameImg) {
            data.append("gameImg", gameImg)
        }
        this.setState({ waiting: true })

        save(data).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("swal.settingsSaved"), "success", 3000))
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    /* Add game image */
    addGameImg = (event) => {
        const img = event.target.files[0]
        if (img) {
            this.setState({ gameImg: img, gameImgUrl: URL.createObjectURL(img) })
        }
    }

    /* Draw Button */
    _button = () => {

        /* Fields */
        const { waiting } = this.state

        /* Loading */
        if (waiting) {
            return <div className="table--settings-button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="table--settings-button">{t("common.save")}</div>
    }

    render = () => {

        /* Fields */
        const { status, data, name, slug, game, gameURL, backURL, backColor, gameImgUrl, room, type } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="table--modal-content table--settings">

                <Input label={t("settings.tableName")} ref={(ref) => this._name = ref} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                <Input label={t("settings.tableKey")} ref={(ref) => this._slug = ref} value={slug} onChange={(event) => this.setState({ slug: event.target.value })} />
                <Input label={t("settings.gameLabel")} ref={(ref) => this._game = ref} value={game} onChange={(event) => this.setState({ game: event.target.value })} />
                <Input label={t("settings.gameURL")} value={gameURL} onChange={(event) => this.setState({ gameURL: event.target.value })} />
                <Input label={t("settings.serverURL")} value={backURL} onChange={(event) => this.setState({ backURL: event.target.value })} />
                <Input label="Background color" value={backColor} onChange={(event) => this.setState({ backColor: event.target.value })} />
                <Input label="Room" value={room} onChange={(event) => this.setState({ room: event.target.value })} />
                <Input label={t("settings.type")} value={type} onChange={(event) => this.setState({ type: event.target.value })} />

                <Input file label={t("settings.image")} value={gameImgUrl} onChange={(event) => this.addGameImg(event)} />

                {gameImgUrl ? <img className="back-img" src={gameImgUrl} alt="gameImg" /> : null}

                <div className="table---settings-element">
                    <span>{t("settings.currentDealer")}</span>
                    <p>{utils.checkValue(data.dealer, "-")}</p>
                </div>

                <CopyToClipboard onCopy={() => Swal.fire(utils.notification(t("settings.tokenCopied"), "success"))} text={utils.checkValue(data.uid, "-")}>
                    <div className="table---settings-element">
                        <span>UNIQUE TOKEN</span>
                        <p>{utils.checkValue(data.uid, "-")}</p>
                        <img src="/images/copy.png" alt="Copy" />
                    </div>
                </CopyToClipboard>

                <CopyToClipboard onCopy={() => Swal.fire(utils.notification(t("settings.tokenCopied"), "success"))} text={utils.checkValue(data.dealerSocketToken, "-")}>
                    <div className="table---settings-element">
                        <span>DEALER MIDDLEWARE TOKEN</span>
                        <p>{utils.checkValue(data.dealerSocketToken, "-")}</p>
                        <img src="/images/copy.png" alt="Copy" />
                    </div>
                </CopyToClipboard>

                <CopyToClipboard onCopy={() => Swal.fire(utils.notification(t("settings.tokenCopied"), "success"))} text={utils.checkValue(data.dealerMonitorToken, "-")}>
                    <div className="table---settings-element">
                        <span>DEALER MONITOR TOKEN</span>
                        <p>{utils.checkValue(data.dealerMonitorToken, "-")}</p>
                        <img src="/images/copy.png" alt="Copy" />
                    </div>
                </CopyToClipboard>

                <CopyToClipboard onCopy={() => Swal.fire(utils.notification(t("settings.tokenCopied"), "success"))} text={utils.checkValue(data.scannerToken, "-")}>
                    <div className="table---settings-element">
                        <span>SCANNER TOKEN</span>
                        <p>{utils.checkValue(data.scannerToken, "-")}</p>
                        <img src="/images/copy.png" alt="Copy" />
                    </div>
                </CopyToClipboard>

                <CopyToClipboard onCopy={() => Swal.fire(utils.notification(t("settings.tokenCopied"), "success"))} text={utils.checkValue(data.adminToken, "-")}>
                    <div className="table---settings-element">
                        <span>ADMIN TOKEN</span>
                        <p>{utils.checkValue(data.adminToken, "-")}</p>
                        <img src="/images/copy.png" alt="Copy" />
                    </div>
                </CopyToClipboard>

                <CopyToClipboard onCopy={() => Swal.fire(utils.notification(t("settings.tokenCopied"), "success"))} text={utils.checkValue(data.atemToken, "-")}>
                    <div className="table---settings-element">
                        <span>ATEM TOKEN</span>
                        <p>{utils.checkValue(data.atemToken, "-")}</p>
                        <img src="/images/copy.png" alt="Copy" />
                    </div>
                </CopyToClipboard>

                <div className="table--settings-remove" onClick={() => this.remove()}>{t("swal.deleteGame")}</div>

                <div className="table--settings-bottom">
                    {this._button()}
                </div>

            </div>
        )
    }

}


const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        operators: state.operators,
    }
}

export default connect(mapStateToProps)(withRouter(Settings))